import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";

export default function Plan() {
  const [data, setData] = useState([]);
  const { variant_id, id } = useParams();
  const GetSubscriptionList = () => {
    axiosInstance
      .post(API_URLS.subscriptionList)
      .then((response) => {
        setData(response?.data?.brand_data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    GetSubscriptionList();
  }, []);

  console.log("GetSubscriptionList", data);
  const navigate = useNavigate();

  return (
    <div className="">
      <div className=" px-3 ">
        <div className=" text-4xl py-5">
          <p className="flex justify-center font-bold !text-center">
            Select Your Plan
          </p>
        </div>

        <div className="flex lg:flex-row flex-col gap-10 pt-10 justify-center">
          {data?.map((item) => {
            return (
              <Button
                variant="contained"
                className="hm1 !p-4 !px-5"
                onClick={() => {
                  item.id === 5 &&
                    navigate(`/monthly/${item.id}/${variant_id}`);
                  item.id === 6 &&
                    navigate(`/quater/${item.id}/${variant_id}/${item.id}`);
                  item.id === 7 && navigate(`/yearly/${item.id}/${variant_id}`);
                }}
              >
                {item?.subscription_name}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
